export enum AnimationType {
  Fade = "fade",
  Slide = "slide",
}
